(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ProcedureModifier', ProcedureModifier);

    ProcedureModifier.$inject = ['$resource'];

    function ProcedureModifier ($resource) {
        var resourceUrl =  'api/procedure-modifiers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByProcedure': {
                url: 'api/procedure-modifiers/procedure/:id',
                method: 'GET',
                isArray: true
            }
        });
    }
})();
